import React, { Component } from 'react';
import { connect } from 'react-redux';
import clone from 'clone';
import { Link } from 'react-router-dom';
import {Layout, Tooltip} from 'antd';
import options from './options';
import Scrollbars from '../../components/utility/customScrollBar.js';
import Menu from '../../components/uielements/menu';
import IntlMessages from '../../components/utility/intlMessages';
import SidebarWrapper from './sidebar.style';
import appActions from '../../redux/app/actions';
import Logo from '../../components/utility/logo';
import Icon from '../../image/svg/icons';
import MenuIcon from '@material-ui/icons/Menu';
import {IconButton} from '@material-ui/core'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
const SubMenu = Menu.SubMenu;
const { Sider } = Layout;

const {
    toggleOpenDrawer,
    changeOpenKeys,
    changeCurrent,
    toggleCollapsed
} = appActions;
const stripTrailingSlash = str => {
    if (str.substr(-1) === '/') {
        return str.substr(0, str.length - 1);
    }
    return str;
};

class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.onOpenChange = this.onOpenChange.bind(this);
    }
    handleClick(e) {
        this.props.changeCurrent([e.key]);
        if (this.props.app.view === 'MobileView') {
            setTimeout(() => {
                this.props.toggleCollapsed();
                this.props.toggleOpenDrawer();
            }, 100);
        }
    }
    onOpenChange(newOpenKeys) {
        const { app, changeOpenKeys } = this.props;
        const latestOpenKey = newOpenKeys.find(
            key => !(app.openKeys.indexOf(key) > -1)
        );
        const latestCloseKey = app.openKeys.find(
            key => !(newOpenKeys.indexOf(key) > -1)
        );
        let nextOpenKeys = [];
        if (latestOpenKey) {
            nextOpenKeys = this.getAncestorKeys(latestOpenKey).concat(latestOpenKey);
        }
        if (latestCloseKey) {
            nextOpenKeys = this.getAncestorKeys(latestCloseKey);
        }
        changeOpenKeys(nextOpenKeys);
    }
    getAncestorKeys = key => {
        const map = {
            sub3: ['sub2']
        };
        return map[key] || [];
    };
    getMenuItem = ({ singleOption, submenuStyle, submenuColor, userPermissions, admin }) => {
        const { key, label, leftIcon, children, svg } = singleOption;

        const url = stripTrailingSlash(this.props.url);
        if (children) {
            return (
                <SubMenu
                    key={key}
                    title={
                        <span className="isoMenuHolder">
                            {
                                leftIcon ?
                                    <i className={leftIcon} />
                                    : svg &&
                                    <i>{<Icon icon={svg} />}</i>
                            }
                            <span className="nav-text">
                                <IntlMessages id={label} />
                            </span>
                        </span>
                    }
                >
                    {children.map(child => {
                        if (admin || child.permitted.some(r => userPermissions.includes(r))) {
                            const linkTo = child.withoutDashboard
                                ? `/${child.key}`
                                : `${url}/${child.key}`;
                            return (
                                <Menu.Item style={submenuStyle} key={child.key}>
                                    <Link style={submenuColor} to={linkTo}>
                                        <IntlMessages id={child.label} />
                                    </Link>
                                </Menu.Item>
                            );
                        }
                        return;
                    })}
                </SubMenu>
            );
        }
        return (
            <Menu.Item key={key}>
                <Link to={`${url}/${key}`}>
                    <span className="isoMenuHolder" style={submenuColor}>
                        <i className={leftIcon} />
                        <span className="nav-text">
                            <IntlMessages id={label} />
                        </span>
                    </span>
                </Link>
            </Menu.Item>
        );
    };
    render() {
        const { app, toggleOpenDrawer, customizedTheme, height, userPermissions, admin, addMenu, toggleCollapsed } = this.props;
        const { openDrawer } = app;
        const collapsed = this.props.collapsed;
        const mode = collapsed === true ? 'vertical' : 'inline';
        const onMouseEnter = event => {
            if (openDrawer === false) {
                toggleOpenDrawer();
            }
            return;
        };
        const onMouseLeave = () => {
            if (openDrawer === true) {
                toggleOpenDrawer();
            }
            return;
        };
        const styling = {
            backgroundColor: customizedTheme.backgroundColor
        };
        const submenuStyle = {
            color: customizedTheme.textColor
        };
        const submenuColor = {
            color: customizedTheme.textColor
        };
        return (
            <SidebarWrapper>
                <Sider
                    trigger={null}
                    collapsible={true}
                    collapsed={collapsed}
                    width={240}
                    className="isomorphicSidebar"
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                    style={styling}
                >
                    <Logo collapsed={collapsed} />
                    <Scrollbars style={{ height: height - 70  }}>
                        <div style={collapsed ? {display: "flex", justifyContent: "center", alignItems: "center", marginTop: "20px"} : {paddingLeft: "12px", marginTop: "20px"}}>
                            <Tooltip placement="right" title="Expand/Collapse">
                                <IconButton
                                    type="button"
                                    style={{color: customizedTheme.textColor}}
                                    onClick={toggleCollapsed}
                                >
                                    <MenuIcon className="menuIcon"/>
                                </IconButton>
                            </Tooltip>
                                <div style={collapsed ? {display: "none"} : {display: "inline", float: "right"}}
                                     onClick={toggleCollapsed}>
                                    <IconButton
                                        style={{color: customizedTheme.textColor}}>
                                        <ChevronLeftIcon className="menuIcon"/>
                                    </IconButton>
                                </div>
                        </div>
                        <Menu
                            onClick={this.handleClick}
                            theme="dark"
                            className="isoDashboardMenu"
                            mode={mode}
                            openKeys={collapsed ? [] : app.openKeys}
                            selectedKeys={app.current}
                            onOpenChange={this.onOpenChange}
                        >
                            {options.map(singleOption => {
                                if (admin || singleOption.permitted.some(r => userPermissions.includes(r))) {
                                    addMenu(singleOption);
                                    return this.getMenuItem({ submenuStyle, submenuColor, singleOption, userPermissions, admin });
                                }
                                return;
                            }
                            )}
                        </Menu>
                    </Scrollbars>
                </Sider>
            </SidebarWrapper>
        );
    }
}

export default connect(
    state => ({
        app: state.App,
        customizedTheme: state.ThemeSwitcher.sidebarTheme,
        height: state.App.height,
        admin: state.Auth.user && state.Auth.user.isSuperAdmin,
        userPermissions: state.Auth.user && state.Auth.user.permissions,
        collapsed: state.App.collapsed
    }),
    { toggleOpenDrawer, changeOpenKeys, changeCurrent, toggleCollapsed }
)(Sidebar);
